import { useAppSelector } from '@/store/hooks/redux';
import { useEffect, useState } from 'react';
import axiosInstance from '@/shared/services/api/axios.api';
import type { IMediaLibraryImageModel } from '@/shared/models/media-library/media-library-image.model';

const useImageCropper = (image?: IMediaLibraryImageModel) => {
  const [cropperLoading, setCropperLoading] = useState(false);
  const [imageBlob, setImageBlob] = useState<string | null>(null);
  // possibility to make cropper dynamic based on platform and requirements
  // for now mocked and dumy
  const [aspectRatio, setAspectRatio] = useState('9 / 16');
  const [croppingInProgress, setCroppingInProgress] = useState<boolean>(false);

  const modalState = useAppSelector((state) => state.editorModalsDrawersReducer.imageCropper);

  const whatToCrop = image ? image : modalState.image!;

  useEffect(() => {
    async function loadImage() {
      if (whatToCrop?.preSignedUrl) {
        setCropperLoading(true);
        const res = (
          await axiosInstance.get(`medias/${whatToCrop?.id}/proxy`, {
            responseType: 'blob',
          })
        ).data;
        const fileReader = new FileReader();
        fileReader.onload = () => {
          setImageBlob(fileReader.result as string);
          setCropperLoading(false);
        };

        fileReader.readAsDataURL(res);
      }
    }

    loadImage();

    return () => {
      setImageBlob(null);
      setCropperLoading(false);
    };
  }, [whatToCrop?.id, whatToCrop?.preSignedUrl]);

  return {
    cropperLoading,
    setCropperLoading,
    imageBlob,
    setImageBlob,
    modalState,
    croppingInProgress,
    setCroppingInProgress,
  };
};

export default useImageCropper;
